"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _createSvgIcon = _interopRequireDefault(require("../utils/createSvgIcon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _default = exports["default"] = (0, _createSvgIcon["default"])( /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("title", null, "Password-Show"), /*#__PURE__*/_react["default"].createElement("polygon", {
  points: "18.33 11.93 13.64 11.95 11.31 16.01 13.67 20.07 18.36 20.05 20.69 15.99 18.33 11.93"
}), /*#__PURE__*/_react["default"].createElement("path", {
  d: "M16,24.44c-5,0-9.73-3.1-12.26-8.11a.68.68,0,0,1,0-.59c2.51-5,7.2-8.17,12.24-8.18h0c5,0,9.73,3.1,12.26,8.11a.68.68,0,0,1,0,.59c-2.51,5-7.2,8.17-12.24,8.18ZM5,16c2.35,4.41,6.51,7.14,11,7.11S24.64,20.39,27,16C24.62,11.57,20.45,8.86,16,8.86h0C11.53,8.87,7.36,11.61,5,16Z"
}), /*#__PURE__*/_react["default"].createElement("g", {
  id: "Artboard-32"
})));
module.exports = exports.default;